'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.forTesting = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _withState = require('recompose/withState');

var _withState2 = _interopRequireDefault(_withState);

var _withHandlers = require('recompose/withHandlers');

var _withHandlers2 = _interopRequireDefault(_withHandlers);

var _withPropsOnChange = require('recompose/withPropsOnChange');

var _withPropsOnChange2 = _interopRequireDefault(_withPropsOnChange);

var _composeWithScope = require('recompose-scope/composeWithScope');

var _composeWithScope2 = _interopRequireDefault(_composeWithScope);

var _injectProps = require('recompose-scope/injectProps');

var _injectProps2 = _interopRequireDefault(_injectProps);

var _exposeProps = require('recompose-scope/exposeProps');

var _exposeProps2 = _interopRequireDefault(_exposeProps);

var _linkHandlersAfter = require('coact-utils/linkHandlersAfter');

var _linkHandlersAfter2 = _interopRequireDefault(_linkHandlersAfter);

var _setWrappedDisplayName = require('coact-utils/setWrappedDisplayName');

var _setWrappedDisplayName2 = _interopRequireDefault(_setWrappedDisplayName);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var onInputChange = function onInputChange(_ref) {
  var setInput = _ref.setInput;
  return function (input) {
    return setInput(input);
  };
};

function equalIgnoreCase(s1, s2) {
  if (typeof s1 !== 'string') return false;
  // s2 is input, should be string

  return s1.toUpperCase() === s2.toUpperCase();
}
function makeIsFullMatch(_ref2) {
  var refKeys = _ref2.refKeys;

  if (!refKeys) return function (opt, input) {
    return equalIgnoreCase(opt, input);
  };

  return function (opt, input) {
    return refKeys.some(function (key) {
      return equalIgnoreCase(opt[key], input);
    });
  };
}
function moveToFirst(index, arr) {
  return [arr[index]].concat(_toConsumableArray(arr.slice(0, index)), _toConsumableArray(arr.slice(index + 1)));
}
function moveFullMatchFirst(_ref3) {
  var isFullMatch = _ref3.isFullMatch,
      options = _ref3.options,
      input = _ref3.input;

  var index = options.findIndex(function (opt) {
    return isFullMatch(opt, input);
  });
  if (index === -1) return options;
  return moveToFirst(index, options);
}

var array = _propTypes2.default.array,
    any = _propTypes2.default.any,
    func = _propTypes2.default.func;

var enhancer = (0, _composeWithScope2.default)((0, _injectProps2.default)({
  refKeys: array,
  options: array.isRequired,
  value: any,
  onInputChange: func
}), (0, _withState2.default)('input', 'setInput', ''), (0, _withHandlers2.default)((0, _linkHandlersAfter2.default)({ onInputChange: onInputChange })), (0, _withPropsOnChange2.default)(['refKeys'], function (props) {
  return {
    isFullMatch: makeIsFullMatch(props)
  };
}), (0, _exposeProps2.default)(function (props) {
  return {
    options: moveFullMatchFirst(props),
    onInputChange: props.onInputChange
  };
}));

exports.default = (0, _setWrappedDisplayName2.default)(enhancer, 'moveFullMatchFirst');


var forTesting = { moveToFirst: moveToFirst };
exports.forTesting = forTesting;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/inputs/enhancers/processOptions/moveFullMatchFirst.js
// module id = 1643
// module chunks = 0